import SvgIcon from './SvgIcon.vue';
import FinancialsItem from './FinancialsItem.vue';
import CommonItem from './CommonItem.vue';
import Empty from './Empty.vue';
import CustomTabs from './CustomTabs.vue';
import DarkButton from './DarkButton.vue';
import ViewMoreButton from './ViewMoreButton.vue';

const components = {
	SvgIcon,
	FinancialsItem,
	CommonItem,
	Empty,
	CustomTabs,
	ViewMoreButton,
	DarkButton
};

export default {
	install(Vue) {
		Object.keys(components).forEach(it => {
			Vue.component(it, components[it]);
		});
	}
};
